var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueApexCharts',{attrs:{"type":"area","height":_vm.height,"options":_vm.chartOptions,"series":_vm.dataSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }